import { Button, Select, Tag } from 'antd'
import { BaseOptionType } from 'antd/es/select'

export type Props<TItem extends BaseOptionType, TValue> = {
  options: TItem[]
  selectedValues: TValue[]
  onChange?: (selectedValues: TValue[]) => void
  style?: React.CSSProperties
  maxTagCount: number
  placeholder: string
  labelFieldName?: keyof TItem & string
  valueFieldName?: keyof TItem & string
  tagRender?: (value: TValue) => React.ReactElement
  allSelectedText?: string
  disabled?: boolean
}

const MultiSelect = <TItem extends BaseOptionType, TValue>(props: Props<TItem, TValue>) => {
  const {
    options,
    selectedValues,
    onChange = () => { },
    style = {},
    maxTagCount,
    placeholder,
    labelFieldName = 'label',
    valueFieldName = 'value',
    tagRender,
    allSelectedText = 'All Selected',
    disabled
  } = props

  const allSelected = selectedValues.length === options.length
  const additionalTags = selectedValues.length - maxTagCount

  const allButtonClicked = () => {
    if (allSelected) {
      onChange([])
    } else
      onChange(options.map(o => o[valueFieldName]))
  }

  return <Select
    style={style}
    mode="multiple"
    placeholder={placeholder}
    value={selectedValues}
    onChange={onChange}
    allowClear
    maxTagCount={allSelected ? 0 : maxTagCount}
    maxTagPlaceholder={<>{allSelected ? allSelectedText : `+ ${additionalTags} More`}</>}
    fieldNames={{ label: labelFieldName, value: valueFieldName }}
    options={options}
    tagRender={tagRender ? p => <Tag {...p}>{tagRender(p.value)}</Tag> : undefined}
    popupRender={(menu) => {
      return <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Button onClick={allButtonClicked} style={{ marginBottom: 12, alignSelf: 'center' }}>
          {allSelected ? 'Clear All' : 'Select All'}
        </Button>
        {menu}
      </div>
    }}
    disabled={disabled}
  />
}
export default MultiSelect
